import {Vue} from "ui.vue";

let VideoMixin = {
	methods: {
		showVideo: function(link) {
			$.magnificPopup.open({
				type: 'iframe',
				items: {
					src: link,
				},
				mainClass: '',
				alignTop: false,
				closeOnContentClick: false,
				callbacks: {
					open: function () {
						window.addEventListener('message', function (event) {
							let player = document.getElementsByClassName("mfp-iframe")[0];

							try {
								let message = JSON.parse(event.data);
								switch (message.type) {
									case 'player:player:ready':
									case 'player:playComplete':
									case 'player:rollState':
										player.contentWindow.postMessage(JSON.stringify({type:'player:play', data:{}}), '*');
										break;
								}
							} catch(err) {
								console.debug(err, event);
								setTimeout(function (){
									player.contentWindow.postMessage(JSON.stringify({type:'player:play', data:{}}), '*');
								}, 1000);
							}
						});
					}
				}
			});
		},
		closeVideo: function() {
			return $.magnificPopup.instance && $.magnificPopup.instance.close();
		},
	}
};

export {VideoMixin};

